<template>
  <div style="background: #fff;">
    <div style="font-size:30px;font-weight:bold;color:#000;margin:34px 0 30px 118px;">Tax Exempt Certificates</div>
    <div style="font-size:18px;color:#343434;line-height:24px;margin:0 118px;">A tax exemption certificate is an official document availabl e from the State(US only)that waives the application of tax to an order. If you have any questions,please contact our <span style="color:#346b7d;">Sales Department.</span></div>
    <div style="font-size:18px;color:#343434;line-height:24px;margin:12px 118px 25px 118px;"><span style="font-weight:bold;">Note</span>: By providing a tax certificate via the below upload to ol, you will not be charged tax at checkout.Howeverif you provic le a tax certificate to our Sales department via email or fax, you will see a tax charge at checkoutbut will not becharg ed tax at invoice.You do not need to upload a certificate each tim e you place an order.</div>
    <div style="font-size:24px;font-weight:bold;color:#000;margin:0 0 50px 118px;">Upload a Certificate</div>
    <el-form autoComplete="on"
               :model="taxForm"
               :rules="taxRules"
               label-position="right" label-width="200px"
               ref="taxForm"
               class="box-content">
        <el-form-item prop="title" label="Title of Certificate">
          <el-input name="title" class="ipt"
                   type="text"
                    v-model="taxForm.title"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <el-form-item prop="expirationDate" label="Expiration Date">
          <!-- <el-input name="expirationDate" class="ipt"
                    type="text"
                    v-model="taxForm.expirationDate"
                    autoComplete="off"
                    placeholder="">
          </el-input> -->
          <el-date-picker v-model="taxForm.expirationDate" class="ipt"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="Choose File" label="Choose File">
          <upload v-model="taxForm.filePath"></upload>
        </el-form-item>
        <el-form-item prop="" label="">
          <p style="width:572px;color:#8d8d8d;font-size:18px;">Only PDF file formats are valid in Acrobat version 6 (PDF version 1.5) 
or higher. Maximum4MB file size allowed.</p>
        </el-form-item>
        <el-form-item>
          <a class="loginBtn a1" style="margin-bottom:78px;" :loading="loading" @click="handleTax">
            SUBMIT
          </a>
        </el-form-item>
      </el-form>
      <div style="font-size:24px;font-weight:bold;color:#000;margin:0 0 30px 118px;">Uploaded Certificates</div>
      <div style="font-size:18px;margin:0 0 132px 118px;color:#343434;">You do not have any tax exemption certificates uploaded.</div>
  </div>
</template>
<script>
    import { addOrUpdateTax } from '@/api/Persona/index' ;
    import upload from "@/utils/upload.vue";
    const defaultTax = {
      title: '',
      expirationDate: '',
      filePath: '',
    };
    export default {
        name: 'Taxcertificates',
        components: { upload },
        data () {
            return {
              taxForm: Object.assign({}, defaultTax),
              taxRules: {
                title: [{required: true, message: 'Enter', trigger: 'blur'}],
                expirationDate: [{required: true, message: 'Enter', trigger: 'blur'}],
                // filePath: [{required: true, message: 'Enter', trigger: 'blur'}],
              },
              loading: false,
            }
        },
        methods: {
          handleTax () {
            this.$refs.taxForm.validate(valid => {
              if (valid) {
                this.loading = true;
                addOrUpdateTax(this.taxForm).then((res) => {
                    console.log(res, 'taxForm');
                    this.loading = false
                    this.$message.success("Upload successful");
                    window.location.reload();
                }).catch(() => {
                    this.loading = false
                });
              } else {
                return false
              }
            })
          }
        },
    }
</script>

<style scoped>
  .box-content {
    width:1000px;
    margin: auto;
  }
  .ipt {
    width:572px;
    height: 36px;
  }
  .loginBtn {
    background:#00718c;
    color: #fff;
    border-radius: 6px;
    font-size:20px;
    font-weight:bold;
    padding: 16px 12px;
  }
</style>